<template>
    <b-field  :label="getLabel" horizontal>
        <b-input
                size="is-small"
                v-model="carac.clef"
                placeholder="Clef"
                :disabled="waitingSave===false ? true : false"
        >
        </b-input> =>  <b-input
            size="is-small"
            v-model="carac.valeur"
            placeholder="valeur par défaut ou vide"
    >
    </b-input>
        <b-button type="is-danger is-small"
                  icon-right="trash" @click="deleteMe"></b-button>
        <b-button type="is-warning is-small"
                  icon-right="eye" @click="showMe" v-if="waitingSave===false"></b-button>
    </b-field>

</template>

<script>
    export default {
        name: 'parametre',
        data (){
            return {

            }
        },
        components: {},
        props: ['carac','waitingSave','label'],
        computed: {

            getLabel()
            {
                return this.label+"."
            },
            isActive(){
                let tmp=this.$store.getters.isSomeThingToShow;
                if(tmp===this.carac.clef)
                    return true
                else
                    return false
            }

        },
        methods: {


            deleteMe()
            {
                if(this.waitingSave){
                    this.$emit('deleteMe',this.carac)
                }
                else{
                    this. confirmParamDelete()
                }
            },

            async deleteMeHard(){
                // La c'est compliqué, il faut chercher la clef partout

                const used=await this.$mydb.do.getCaracClef(this.getLabel+""+this.carac.clef)

                for(const thecarac of used) {
                    await this.$mydb.do.deleteCarac(thecarac.id)
                }

                this.$emit('deleteMe',this.carac)

                const toEdit={
                    name:'TabHelp',
                    config:''
                }
                this.$store.commit('DROITE_SET',toEdit);

                return true
            },

            showMe(){

                let tmp=this.$store.getters.isSomeThingToShow;
                //implementation d'un toggle
                if(tmp!==this.carac.clef){
                    this.$store.commit('SET_SHOWINGKEY',this.getLabel+""+this.carac.clef)
                }
                else{
                    this.$store.commit('SET_SHOWINGKEY','')
                }

            },

            confirmParamDelete() {
                this.$dialog.confirm({
                    title: 'Effacer un paramètre',
                    message: 'Attention! cela va effacer ce paramètre partout où il est utilisé',
                    confirmText: 'EFFACE',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteMeHard()
                })
            }
        },
        async mounted(){


            //const result=await this.$mydb.do.getCarac(this.letype,this.lieu,this.objet)
            //if(result)
             //   this.carac=JSON.parse(JSON.stringify(result[0]))
        }
    }

</script>


<style lang="scss">

    .myLabel{
        display:inline-block;
    }

    .lineField{
        width:100%;
        height:auto;
    }

    .active{
        color:white !important;
        background-color: red !important;
    }
</style>